import React, { useState } from 'react';

import { useQuery } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useRegenerateAPITokenMutation } from 'components/hooks/APITokenMutations';

import FilledButton from 'components/application/buttons/FilledButton';
import SuccessToast from 'components/application/SuccessToast';

import { useBreadBoard } from 'components/contexts/Toaster';
import RegenerateAPITokenModal from 'components/settings/externalIntegrationConfiguration/components/RegenerateAPITokenModal';

import { resourceShape } from 'components/helpers/serialisableResources';

export default function APITokenConfiguration({ seedAPIToken }) {
  const breadBoard = useBreadBoard();

  const regenerateAPITokenMutation = useRegenerateAPITokenMutation();

  const [isRegenerateAPITokenModalOpen, setIsRegenerateAPITokenModalOpen] =
    useState(false);

  const { t: i18nT } = useTranslation('components', {
    keyPrefix:
      'settings.externalIntegrationConfiguration.components.APITokenConfiguration',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  // query function not required, provided initial data, then data updated via mutation
  const { data: domainAPIToken } = useQuery({
    queryKey: ['APIToken'],
    initialData: seedAPIToken,
    enabled: false,
  });

  const handleRegenerateAPIToken = () => {
    regenerateAPITokenMutation.mutate(
      {},
      {
        onSuccess: () => {
          breadBoard.addToast(
            <SuccessToast
              message={i18nT('update.success')}
              onBurnToast={breadBoard.handleBurnToast}
            />,
          );
        },
        onError: () => {
          breadBoard.addInedibleToast({
            fullMessage: i18nT('update.error'),
          });
        },
      },
    );

    setIsRegenerateAPITokenModalOpen(false);
  };

  return (
    <>
      <input
        className='field__input tw-mb-4 tw-border-grey-300 tw-bg-grey-050 tw-font-inter tw-text-m tw-font-normal tw-tracking-auto focus-within:tw-border-blue-300 hover:tw-border-grey-400 hover:focus-within:tw-border-blue-300'
        readOnly={true}
        type='text'
        value={domainAPIToken.data.attributes.accessToken}
      />
      <FilledButton
        color='red'
        onClick={() => setIsRegenerateAPITokenModalOpen(true)}
      >
        {i18nTShared('regenerate')}
      </FilledButton>
      {isRegenerateAPITokenModalOpen && (
        <RegenerateAPITokenModal
          onClose={() => setIsRegenerateAPITokenModalOpen(false)}
          onRegenerate={handleRegenerateAPIToken}
        />
      )}
    </>
  );
}

APITokenConfiguration.propTypes = {
  seedAPIToken: PropTypes.shape({
    data: resourceShape('apiToken'),
  }),
};
